/**
 * Các loại phiếu do trang nhập đổi trả xử lý, lưu qua POST /api/v1/Inward/create-return-in-ward
 * (CreateReturnSaleInWardCommand); đọc phiếu vẫn dùng các API *-in-ward-return cũ.
 * NHAP_DOI_TRA_TRUOC_2025 không thuộc trang này (API mới không nhận), vẫn mở trang cũ.
 * NHAP_HANG_DOI_TRA đã tắt cấu hình loại phiếu (ACTIVE = 0), không thuộc trang này.
 */
export const RETURN_SOURCE_TYPES = ["NHAP_DOI_TRA"] as const;

export type ReturnSourceType = (typeof RETURN_SOURCE_TYPES)[number];

export const isReturnSourceType = (
  sourceType: string | null | undefined,
): sourceType is ReturnSourceType =>
  !!sourceType && (RETURN_SOURCE_TYPES as readonly string[]).includes(sourceType);

/** Cấu hình theo loại phiếu. Thêm khác biệt mới ở đây thay vì rải `if` trong trang. */
export interface ReturnKindConfig {
  label: string;
  /** true: người dùng chọn kho nhập (backend không trả kho). false: kho lấy theo phiếu, chỉ đọc */
  pickWarehouse: boolean;
  /** Có mẫu in phiếu nhập kho (PrintTheReturnReceipt) */
  printable: boolean;
}

export const RETURN_KIND_CONFIG: Record<ReturnSourceType, ReturnKindConfig> = {
  NHAP_DOI_TRA: { label: "Nhập đổi trả", pickWarehouse: true, printable: true },
};

/** Đổi trả chỉ nhập vào kho xử lý, hàng bán, bảo hành hoặc showroom (lọc như trang cũ; backend cũng chặn) */
export const RETURN_WAREHOUSE_CODE_PARTS = ["XL", "HB", "BH", "SR"];

/** Kho bảo hành (attribute3 = "BH") tự lấy vị trí có mã dạng BHxx_XL và không cho đổi, như trang cũ */
export const WARRANTY_WAREHOUSE_FLAG = "BH";
export const WARRANTY_POSITION_PATTERN = /^BH\d+_XL$/;

/** Tình trạng serial mặc định; trang cũ cũng gửi giá trị này cho serial chưa chọn tình trạng */
export const DEFAULT_SERIAL_STATUS = "Bán bình thường";

/** Giới hạn như trang xuất bán */
export const MAX_SERIALS_PER_INWARD = 5000;

/** Độ dài tối đa ghi chú phiếu, giữ như trang cũ */
export const MAX_DESCRIPTION_LENGTH = 300;

/** Chiều cao thanh đầu khối (Loại phiếu / Bên nhận), gồm viền dưới: hai cột dùng chung để thẳng hàng */
export const TOP_BAR_HEIGHT = 60;

/** Chiều cao hàng tiêu đề lưới serial (AG Grid tự cộng thêm 1px viền dưới) */
export const TABLE_HEAD_HEIGHT = 36;
